/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/* prettier-ignore */

import { AuthCredentialsDto } from '../models/AuthCredentialsDto';
import { LoginRequest } from '../models/LoginRequest';
import { ApiError, catchGenericError } from '../core/ApiError';
import { request as __request } from '../core/request';
import { OpenAPI } from '../core/OpenAPI';

export class AuthenticateService {

    /**
     * Authenticate user with email
     * @param requestBody
     * @result AuthCredentialsDto
     * @throws ApiError
     */
    public static async authControllerLogin(
        requestBody: LoginRequest,
    ): Promise<AuthCredentialsDto> {

        const result = await __request({
            method: 'post',
            path: `/api/auth/login`,
            body: requestBody,
        });

        catchGenericError(result);

        return result.body;
    }

}


// WEBPACK FOOTER //
// ./src/services/openapi/generated/services/AuthenticateService.ts